/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPaymentDeviceCatalog} from '../api'

 export const useQueryGetPaymentDeviceCatalog = createReactQueryHook('getPaymentDeviceCatalog', getPaymentDeviceCatalog)
